"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTencentCaptchaCls = exports.defaultSrc = void 0;
const ScriptLoader_1 = require("./ScriptLoader");
exports.defaultSrc = 'https://turing.captcha.qcloud.com/TCaptcha.js';
const getTencentCaptchaCls = (src) => __awaiter(void 0, void 0, void 0, function* () {
    const ret = window.TencentCaptcha;
    if (ret)
        return ret;
    yield (0, ScriptLoader_1.asyncLoadScript)('head', { src });
    return window.TencentCaptcha;
});
exports.getTencentCaptchaCls = getTencentCaptchaCls;
function getCaptcha(appid, src = exports.defaultSrc, options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const TencentCaptcha = yield (0, exports.getTencentCaptchaCls)(src);
        return new Promise((resolve, reject) => {
            new TencentCaptcha(appid, (res) => {
                const { ret, ticket, randstr } = res;
                if (ret === 0) {
                    if (!appid) {
                        reject(new Error(`无法获取验证码 appid got ${appid}`));
                    }
                    else if (!randstr) {
                        reject(new Error(`无法获取验证码 randstr got ${randstr}`));
                    }
                    else if (!ticket) {
                        reject(new Error(`无法获取验证码 ticket got ${ticket}`));
                    }
                    else {
                        resolve({ CaptchaAppId: appid, randstr, ticket });
                    }
                }
                else if (res.ret === 2) {
                    reject(new Error('你已取消图形验证'));
                }
                else {
                    reject(new Error(`无法获取验证码 [${res.errorCode}]${res.errorMessage}`));
                }
            }, options).show();
        });
    });
}
exports.default = Object.assign(getCaptcha, { defaultSrc: exports.defaultSrc, getTencentCaptchaCls: exports.getTencentCaptchaCls });
//# sourceMappingURL=index.js.map